import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

const ClientAbout = () => {
    return (
        <>
<ClientHeader />
<main className="overflow-hidden">
    <section className="homepad-about" id="mission">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 font-size-16 font-weight-normal line-hight-3 text-muted mt-4 mt-lg-0 pt-3 pt-lg-0">
                  <div className="ps-lg-4 ps-xl-5">
                    <div>
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        Learn More About Our Mission
                      </div>
                    </div>
                    <h2 className="font-weight-bold montserrat text-primary font-size-46 my-3 my-lg-4 py-xl-2 lh-1">
                      At The Just Generation Foundation, our mission is simple yet transformative:
                    </h2>

                    <p>
                      To identify and support young children with developmental needs as early as possible, by building a unified national network of parents, caregivers, licensed professionals, and child care centers—powered by technology, trust, and compassion.
                    </p>
                    <p className="mt-3">
                      <strong>We believe:</strong><br />
                      - Every parent deserves a roadmap and trusted guidance<br />
                      - Every provider deserves tools to make a difference<br />
                      - Every child deserves a chance to thrive—regardless of zip code, income, or background
                    </p>
                    <p className="mt-3">
                      With smart automation, AI-powered matching, and a pre-screened provider referral system, we’re eliminating barriers and delays in early childhood intervention.
                    </p>
                    <p className="mt-3">
                      Whether you're a family navigating a first concern or a provider ready to serve more effectively, we’re here to connect the dots and build the future—together.
                    </p>
                                        <div className="mt-5">
                      <div className="bg-primary-heading font-weight-semibold font-size-18 text-capitalize p-1 rounded-pill d-inline-block text-white pe-4">
                        <span className="bg-yellow d-inline-block p-1 bg-primary-heading rounded-pill favicon-logo01 text-center me-2">
                          <img src="/assets/images/favicon-logo01.svg" alt="..." className="rounded-circle" />
                        </span>
                        Our Vision
                      </div>
                    </div>
                    <p className="mt-3">
                      We envision a world where no child is left waiting, where families are equipped with tools—not guesswork—and where communities are empowered to intervene early, effectively, and with compassion.
                      Together, we can build a Just Generation—one child, one family, one breakthrough at a time.
                    </p>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="position-relative">
                    <img src="/assets/images/about-img.jpg" alt="..." className="w-100 how-it-work-img-about" />
                  </div>
                </div>
              </div>
            </div>
          </section>
</main>
<ClientFooter />
        </>
    );
}
export default ClientAbout;
